import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { SeoTags } from "../../components";
import { RulesOfUse } from "../../components/info/RulesOfUseComponent";
import { setShowSearch } from "../../store/appConfigsSlice";

const RulesOfUsePage = () => {
	const dispatch = useDispatch();

	useEffect (() => {
		dispatch((setShowSearch(false)))
	}, []);

	return (
		<>
			<SeoTags pageKey="rulesOfUsePage" />
			<RulesOfUse />
		</>
	)
}

export default RulesOfUsePage;